import { CASES } from './constants';
import {
    PAGINATION_STORAGE_KEYS,
    DEFAULT_PAGE_SIZE_OPTIONS,
    getStoredItemsPerPage,
    getInitialPaginationRange,
    withPreservedPagination,
    persistItemsPerPage,
} from 'datastage/utils/paginationPreferences.js';

const getInitialDateMathSort = () => {
    const saved = localStorage.getItem('dateMathSort');
    return saved ? JSON.parse(saved) : ['id', 'DESC'];
};

/**
 * Gets the initial items per page from localStorage.
 * Falls back to 20 (Date Math default) if not found.
 */
const getInitialItemsPerPage = () => {
    return getStoredItemsPerPage(PAGINATION_STORAGE_KEYS.dateMath, 20);
};

// Initialize with stored preference
const initialItemsPerPage = getInitialItemsPerPage();

/**
 * Initial state for the date math slice.
 *
 * Key state values:
 * - jobs: Array of date math job objects for the grid
 * - filterForm: Search form field values
 * - isMacrosOpen: Boolean to control macros drawer visibility
 * - refreshDateMath: Boolean flag to trigger grid refresh from other components
 * - itemsPerPage: User's persisted page size preference (from localStorage)
 */
const initialState = {
    jobs: [],
    filterForm: {
        jobId: '',
        jobType: '',
        jobStatus: '',
    },
    isMacrosOpen: false,
    macroTypes: [{ value: 'HoldBack', label: 'HoldBack' }],
    beforeAfterOptions: [
        { value: 'Before', label: 'Before' },
        { value: 'After', label: 'After' },
    ],
    startDateTriggers: {
        useExistingStartDate: true,
        years: '',
        months: '',
        weeks: '',
        days: '',
        dayType: '',
        beforeAfter: '',
    },
    endDateTriggers: {
        useExistingEndDate: true,
        years: '',
        months: '',
        weeks: '',
        days: '',
        dayType: '',
        beforeAfter: '',
    },
    dealSelected: '',
    selectedMacroType: [{ value: 'HoldBack', label: 'HoldBack' }],
    jobStatusOptions: [],
    jobTypeOptions: [],
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    dateMathRange: getInitialPaginationRange(initialItemsPerPage),
    dateMathSort: getInitialDateMathSort(),
    defaultFilterRange: getInitialPaginationRange(initialItemsPerPage),
    itemsPerPage: initialItemsPerPage,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    // Flag to trigger grid refresh from other components
    refreshDateMath: false,
};

export function dateMath(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_DATE_MATH: {
            // Persist sort preference to localStorage
            if (payload.dateMathSort) {
                localStorage.setItem('dateMathSort', JSON.stringify(payload.dateMathSort));
            }
            // Persist page size preference to localStorage
            if (payload.itemsPerPage !== undefined) {
                persistItemsPerPage(PAGINATION_STORAGE_KEYS.dateMath, payload.itemsPerPage);
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_DATE_MATH_SEARCH_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.UPDATE_MACRO_TRIGGERS: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_DATE_MATH_MACROS: {
            return {
                ...state,
                startDateTriggers: initialState.startDateTriggers,
                endDateTriggers: initialState.endDateTriggers,
                dealSelected: initialState.dealSelected,
                selectedMacroType: initialState.selectedMacroType,
            };
        }
        case CASES.CLEAR_DATE_MATH: {
            // Preserve pagination preferences when clearing
            return withPreservedPagination(
                state,
                {
                    ...initialState,
                    jobStatusOptions: state.jobStatusOptions,
                    jobTypeOptions: state.jobTypeOptions,
                    dateMathSort: state.dateMathSort,
                },
                ['dateMathRange', 'defaultFilterRange']
            );
        }
        default:
            return state;
    }
}
